<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :server-items-length="total"
      :options.sync="options"
      class="elevation-1 mb-60"
      @click:row="navigate"
    ></v-data-table>
  </div>
</template>

<style scoped>
.mb-60 {
  margin-bottom: 60px;
}
</style>

<script>
export default {
  name: "TableControl",
  data: () => ({
    loading: false,
    options: {}
  }),
  props: ["model", "items", "total"],
  watch: {
    options: {
      handler() {
        this.$emit("pagination", this.options);
      }
    }
  },
  computed: {
    headers: function() {
      let res = [];

      for (let key in this.model) {
        res.push({
          text: this.model[key].label,
          value: key
        });
      }

      return res;
    }
  },
  methods: {
    navigate: function(row) {
      this.$emit("click:row", row);
    }
  }
};
</script>
